module.exports = __webpack_public_path__ + "static/media/5.b47cb195.png";